/**
 * The funnel's own step marker on `/signup` (`/signup?step=phone`).
 *
 * It exists so BACK works out of an inline phase — see the phone card in
 * `ConnectSocialsLoader`. It is FUNNEL STATE, not attribution: every consumer
 * that treats the query string as data has to skip it, which is why the key
 * lives here rather than in the component that writes it.
 * `captureMarketingParams` filters it out of `onboardingMarketingCapture`
 * (a blacklist, so an unknown key would otherwise be persisted and forwarded
 * to HubSpot as if it were a campaign param) and strips it from the recorded
 * URLs, and `redirectToFinalize` drops it when rebuilding the finalize query.
 */
export const SIGNUP_STEP_PARAM = 'step';

/** `?step=phone` — the phone + SMS card. */
export const PHONE_SIGNUP_STEP = 'phone';

/**
 * `/signup?skip_intro=1` — go straight to the signup screen, past the
 * real-estate intro slide (`RealEstateIntroSlide`). Written with
 * `history.replaceState` when the creator taps through, so a REFRESH of this
 * single-page funnel resumes on the signup screen instead of putting the intro
 * back in front of them. Named for its EFFECT, so a campaign link can carry it
 * deliberately to land a creator on the signup screen directly.
 *
 * Funnel state like `step`, not attribution: filtered out of the marketing
 * capture and the retry / finalize URLs the same way. Unlike `step` it is NOT
 * stripped on reload — surviving the reload is its whole job.
 */
export const SKIP_INTRO_PARAM = 'skip_intro';

/** The one value `skip_intro` takes. */
export const SKIP_INTRO_VALUE = '1';
